import { useEffect } from 'react'

// ZQSD/WASD keyboard panning — App owns key tracking (so it can gate on focused
// inputs / command-palette state) and dispatches the current direction vector on
// every change via a `map-pan-vector` window event; while it's non-zero we pan a
// fixed step per animation frame. Continuous rAF motion instead of one animated
// panBy per key event — key auto-repeat made the old version stutter.
export function useKeyboardPan(map) {
  useEffect(() => {
    const vec = { dx: 0, dy: 0 }
    let raf = null
    const SPEED = 9 // px per frame ≈ 540 px/s at 60fps

    const step = () => {
      if (!map.current || (vec.dx === 0 && vec.dy === 0)) { raf = null; return }
      map.current.panBy([vec.dx * SPEED, vec.dy * SPEED], { duration: 0, animate: false })
      raf = requestAnimationFrame(step)
    }
    const onVector = (e) => {
      vec.dx = e.detail?.dx || 0
      vec.dy = e.detail?.dy || 0
      if ((vec.dx || vec.dy) && raf == null) raf = requestAnimationFrame(step)
    }
    window.addEventListener('map-pan-vector', onVector)
    return () => {
      window.removeEventListener('map-pan-vector', onVector)
      if (raf != null) cancelAnimationFrame(raf)
    }
  }, [map])
}
